package com.essntl.features.contact.ui

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class ContactValidation {
    val contactForm = ContactForm()
}

class ContactForm : Form() {
    val name = StringField(NonEmptyValidator)

    override val fields: List<Field>
        get() = listOf(name)
}